var t;!function(t){t.TO_RIGHT="to right",t.TO_BOTTOM_RIGHT="to bottom right"}(t||(t={}));export{t as Directions};
//# sourceMappingURL=ColorRectangleModel.js.map
